import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const LogoWindowsIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "logo-windows",
  "LogoWindowsIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M2 2H14V14H2V2ZM3.33333 3.33333V7.33333H7.33333V3.33333H3.33333ZM8.66667 3.33333V7.33333H12.6667V3.33333H8.66667ZM12.6667 8.66667H8.66667V12.6667H12.6667V8.66667ZM7.33333 12.6667V8.66667H3.33333V12.6667H7.33333Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default LogoWindowsIcon;
